<rt-icon *ngIf="offerStatus.kind === 'talent_pool'" name="talent-pools" size="small-x"></rt-icon>
